// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid-footer","root":"grid-footer-m__root__1Me__"};